import React from "react";
import { LoadIndicator } from "devextreme-react";
import { WithTranslation } from "react-i18next";

interface MaskedStatusForFasterPayProps extends WithTranslation {
    data: any;
}

interface MaskedStatusForFasterPayState {
    fasterPayStatus: string;
}

class MaskedStatusForFasterPay extends React.Component<MaskedStatusForFasterPayProps> {
    state: MaskedStatusForFasterPayState;
    constructor(props: MaskedStatusForFasterPayProps) {
        super(props);
        this.state = {
            fasterPayStatus: this.props.data.data.fasterPayAvailable ? "Available" : "Unavailable",
        };
    }

    //This is needed here to check for some conditions when the component mounts.
    componentDidMount() {}
    render() {
        return (
            <div>
                <div className="d-flex justify-content-between align-items-center">
                    <div className="mr-2 d-flex">
                        <span className="status-message-color">{this.state.fasterPayStatus}</span>
                    </div>
                </div>
            </div>
        );
    }
}

export default MaskedStatusForFasterPay;
